<div class="bottom-sheet-container">
  <div class="row">
    <div class="col-12">
      <button type="button" (click)="close()" class="dialog-close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="text-container">
      <div class="col-12 bottomsheet-question margin-bottom">
        <span>
          <p>{{ data.bottomsheet.question }}</p>
        </span>
      </div>
      <div class="col-12 bottomsheet-text margin-bottom">
        <span>
          <p [innerHTML]="data.bottomsheet.text"></p>
        </span>
      </div>
      <div class="col-12">
        <button class="orange-btn" (click)="handleContinue()" routerLink="/main/dashboard">{{ data.bottomsheet.buttonText }}</button>
      </div>
    </div>
  </div>
</div>
